import Http, * as Endpoint from "../Http";
import * as action from "../store/actions";
import { errorsTransformer } from "../Http";
import { bugsnagClient } from "./bugsnag";

/**
 * Verify payment
 *
 * @returns {function(*=): Promise<unknown>}
 */
export const verify = () => {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get(Endpoint.VERIFY_PAYMENT)
        .then(res => {
          dispatch(action.authDossierLogin(res.data));
          resolve({
            status: res.data.payment_status,
            type: res.data.payment_type,
          });
        })
        .catch(err => {
          reject(errorsTransformer(err));
        });
    });
};

/**
 * Fetch redirect url for payment
 *
 * @param payload
 * @returns {function(*=): Promise<unknown>}
 */
export const getRedirectUrl = payload => {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post(Endpoint.FETCH_PAYMENT_REDIRECT_URL, payload)
        .then(res => {
          dispatch(action.authDossierLogin(res.data));
          if (res.data.redirect_uri) {
            resolve(res.data);
          } else {
            bugsnagClient.notify("Redirect uri not received");
          }
        })
        .catch(err => {
          reject(errorsTransformer(err));
        });
    });
};

export const canRequestPaymentPlan = (paymentPlan, dossier, balance) => {
  return !paymentPlan && !dossier.hasPendingPaymentPlan && balance > 0;
};

export const submitPaymentArrangementRequest = payload => {
  return new Promise((resolve, reject) => {
    Http.post(Endpoint.POST_PAYMENT_ARRANGEMENT_REQUEST, payload)
      .then(res => {
        resolve(res.data.status);
      })
      .catch(err => {
        reject(errorsTransformer(err));
      });
  });
};
